import React, { useState } from 'react'
import ManPart from './ManPart';
import RandomPart from './RandomPart';
import StoreMain from './StoreMain';
import WomanPart from './WomanPart';



function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export default function Storebar() {

    const [storem, setStorem] = useState(<StoreMain />)
    const [nom, setNom] = useState(1)
    const navigation = [
        { name: 'سەرەکی', href: <StoreMain />, num: 1, src: 'https://cdn-icons-png.flaticon.com/64/3028/3028535.png', current: false },
        { name: 'پیاوان', href: <ManPart />, num: 2, src: 'https://cdn-icons-png.flaticon.com/64/7586/7586003.png', current: true },
        { name: 'ئافرەتان', href: <WomanPart />, num: 3, src: 'https://cdn-icons-png.flaticon.com/64/7091/7091053.png', current: false },
        { name: 'کەرەستەی وەرزشی', href: <RandomPart />, num: 4, src: 'https://cdn-icons-png.flaticon.com/64/1198/1198416.png', current: false },
    ]
    return (
        <div className='bg-dwam flex flex-col '>
            <div className='flex flex-row-reverse flex-wrap justify-center md:justify-between p-2'>
                <div className="flex  justify-center w-fit  md:justify-end p-1">
                    {navigation.reverse().map((item) => (
                        <>
                            <button
                                key={item.name}
                                onClick={() => { return( setStorem(item.href), setNom(item.num) )}}
                                className={classNames(
                                    nom === item.num ? ' font-bold  border-b-2 border-b-chwaram text-c7' : ' font-bold  border-b-2 text-shasham hover:text-chwaram hover:border-b-2 hover:border-b-chwaram',
                                    'px-3 py-2  text-md font-bold md:text-2xl '
                                )}
                                aria-current={item.current ? 'page' : undefined}
                            >
                                {item.name}
                            </button>
                        </>

                    ))}
                </div>
               
            </div>
            <div>
                {storem}
            </div>
        </div>
    )
}
